import mucca from "../images/png/animali/mucca2.jpg";
import ivana from "../images/png/ivana/androneivana.png"

function Prenotazione() {

    return (
        <div class="container-fluid text-light " id="prenotazione">
            <div class="containermuro">
                <h1>Effettua la tua prenotazione</h1>
                <div class="d-flex justify-content-around">
                    <div class="row my-10">

                        <div class="col align-self-center shadow-lg p-2 mb-2 bg-body rounded">

                        <div class="card bg-black">
                            <div class="card-header">
                                Chiama al numero
                            </div>
                            <div class="card-body">
                                <blockquote class="blockquote mb-0">
                                <p> ☎: 331-4881141</p>
                                </blockquote>
                            </div>
                            </div>

                        </div>

                            
                        <div class="col">
                            <img src={ivana} alt="..." style={{height: '600px' }} />
                        </div>
                        
                    </div>
                </div>
            </div>
        
        </div>
    );

}

export default Prenotazione;